import { Controller } from "@hotwired/stimulus"
import Uppy from "@uppy/core"

export default class extends Controller {
  static targets = ["dropzone", "input", "counter", "form"]

  connect() {
    this.dragDepth = 0

    this.uppy = new Uppy({
      autoProceed: false,
      restrictions: {
        maxNumberOfFiles: 100
      }
    })

    this.uppy.on("file-added", () => this.syncInput())
    this.uppy.on("file-removed", () => this.syncInput())
    this.uppy.on("files-added", () => this.syncInput())
    this.uppy.on("restriction-failed", (file, error) => {
      console.warn(`Uppy restriction failed for ${file?.name || "file"}: ${error}`)
    })

    this.syncInput()
  }

  disconnect() {
    this.uppy?.close({ reason: "unmount" })
  }

  syncInput() {
    const transfer = new DataTransfer()

    this.uppy.getFiles().forEach((uppyFile) => {
      transfer.items.add(uppyFile.data)
    })

    this.inputTarget.files = transfer.files
    this.counterTarget.textContent = this.counterLabel(transfer.files.length)
  }

  openFilePicker() {
    this.inputTarget.click()
  }

  importSelectedFiles() {
    Array.from(this.inputTarget.files || []).forEach((file) => this.addFile(file))
    this.syncInput()
  }

  dragOver(event) {
    event.preventDefault()
  }

  dragEnter(event) {
    event.preventDefault()
    this.dragDepth += 1
    this.dropzoneTarget.classList.add("is-dragover")
  }

  dragLeave(event) {
    event.preventDefault()
    this.dragDepth = Math.max(0, this.dragDepth - 1)

    if (this.dragDepth === 0) {
      this.dropzoneTarget.classList.remove("is-dragover")
    }
  }

  dragDrop(event) {
    event.preventDefault()
    const droppedFiles = Array.from(event.dataTransfer?.files || [])

    droppedFiles.forEach((file) => this.addFile(file))
    this.syncInput()
    this.resetDragState()

    if (droppedFiles.length > 0) {
      this.submitForm()
    }
  }

  counterLabel(count) {
    if (count === 0) return "Keine Datei ausgewählt."
    if (count === 1) return "1 Datei ausgewählt."

    return `${count} Dateien ausgewählt.`
  }

  addFile(file) {
    try {
      this.uppy.addFile({
        name: file.name,
        type: file.type,
        data: file
      })
    } catch (error) {
      // Duplicate selections are ignored to keep the upload list stable.
      if (error?.isRestriction || error?.name === "RestrictionError" || /duplicate file/i.test(error?.message || "")) return

      throw error
    }
  }

  resetDragState() {
    this.dragDepth = 0
    this.dropzoneTarget.classList.remove("is-dragover")
  }

  submitForm() {
    if (this.inputTarget.files.length === 0) return

    this.formTarget.requestSubmit()
  }
}
